import { t } from "@lingui/macro";

export const PricingPage = () => (
  <main className="container py-24">
    <h1 className="text-4xl font-bold">{t`Pricing`}</h1>
  </main>
);
